import {
  SpreadsheetActionType,
  type SpreadsheetContextMenuItem,
} from "@via/components/spreadsheet-editor/spreadsheet-editor.tsx";
import { formatSpreadsheetCellValue } from "@via/pages/data/premium-dataset/utils/helper";
import type { VmetaFilesMap } from "@via/pages/projects/runs/overview/hooks/useVmetaDatasetFiles";
import { isVmetaCollection } from "@via/pages/projects/runs/overview/inputs/input-file/single-file-spreadsheet";
import {
  DEFAULT_EXCLUDED_VMETA_COLUMNS_SAMPLE_EXPLORER,
  ROUTES,
} from "@via/utils/constants.tsx";
import { type SaveRunInputs } from "common";

export const getVmetaCollectionLink = (
  paramsInputs: SaveRunInputs[],
  inputId: string
): string | undefined => {
  const inputName = inputId.replace("params.", "");
  const param = paramsInputs.find(p => p.name === inputName);
  return isVmetaCollection(param) && param.vmetaCollectionId
    ? `${ROUTES.COLLECTIONS}/${String(param.vmetaCollectionId)}`
    : undefined;
};

export const buildVmetaDatasetMenuItems = (
  vmetaFilesByCollectionId?: VmetaFilesMap
): SpreadsheetContextMenuItem[] => {
  if (
    !vmetaFilesByCollectionId ||
    Object.keys(vmetaFilesByCollectionId).length === 0
  ) {
    return [];
  }

  return Object.entries(vmetaFilesByCollectionId).map(
    ([_, { data, meta, datasetName }]) => {
      const childItems =
        meta?.field_types
          ?.filter(
            fieldType =>
              !DEFAULT_EXCLUDED_VMETA_COLUMNS_SAMPLE_EXPLORER.includes(
                fieldType.name
              )
          )
          .map(fieldType => ({
            label: fieldType.label,
            type: SpreadsheetActionType.PasteCollectionNames,
            onClick: async () => {
              if (!Array.isArray(data)) {
                return [];
              }
              return data.map(file => {
                const rawValue = (file as Record<string, unknown>)[
                  fieldType.name
                ];
                return formatSpreadsheetCellValue(rawValue).value;
              });
            },
          })) ?? [];

      return {
        label: (
          <span>
            Insert from <strong>{datasetName}</strong> dataset
          </span>
        ),
        type: SpreadsheetActionType.Custom,
        children: childItems,
      };
    }
  );
};
